import { $ as e, A as t, F as n, M as r, R as i, U as a, W as o, _ as s, h as c, m as l, t as u, v as d } from "./_plugin-vue_export-helper-CTQVpqU-.js";
import { n as f } from "./shadow-dom-9FbsLIC0.js";
//#region src/webcomponents/common/FocusManager.ce.vue?vue&type=style&index=0&inline&lang.css
var p = ".sr-only{clip-path:inset(50%);white-space:nowrap;border:0;width:1px;height:1px;padding:0;position:absolute;overflow:hidden}", m = ["tabindex"], h = ["tabindex"], g = /*#__PURE__*/ u({
	__name: "FocusManager.ce",
	props: {
		isVisible: {
			type: Boolean,
			default: !1
		},
		autoFocus: {
			type: Boolean,
			default: !0
		},
		loop: {
			type: Boolean,
			default: !0
		}
	},
	setup(u) {
		let p = [
			...[
				"input",
				"select",
				"button",
				"textarea"
			].map((e) => `${e}:not([disabled])`),
			"a[href]",
			"video[controls]",
			"audio[controls]",
			"[tabindex]:not([tabindex^=\"-\"])",
			"[contenteditable]:not([contenteditable=\"false\"])"
		].join(","), g = [], _ = [], v = e(!1), y = e(), b = a("vueFocusLoopContainer"), x = f(), S = u, C = l(() => S.isVisible ? 0 : -1);
		o(() => S.isVisible, () => {
			w();
		}), r(() => {
			w();
		});
		function w() {
			T(S.isVisible), t(() => {
				let e = S.isVisible;
				P(e && S.autoFocus), k(e);
			});
		}
		function T(e) {
			!e && window.vflPrevFocusedElement ? window.vflPrevFocusedElement.focus() : x instanceof ShadowRoot ? window.vflPrevFocusedElement = x.activeElement : window.vflPrevFocusedElement = document.activeElement;
		}
		function E() {
			g = [], _ = [];
		}
		function D() {
			O(x);
		}
		function O(e) {
			let t = !0;
			_.push(e);
			let n = Array.from(e.children);
			return n.length !== 0 && n.forEach((e) => {
				e === b.value ? t = !1 : O(e) || (t = !1);
			}), t && e.getAttribute("aria-hidden") !== "true" && g.push(e), t;
		}
		function k(e) {
			e ? (D(), A()) : (j(), E());
		}
		function A() {
			N("true"), _.filter(M).forEach((e) => {
				e.hasAttribute("tabindex") && e.setAttribute("old-tabindex", e.getAttribute("tabindex")), e.setAttribute("tabindex", "-1");
			});
		}
		function j() {
			N("false"), _.filter(M).forEach((e) => {
				e.hasAttribute("old-tabindex") ? (e.setAttribute("tabindex", e.getAttribute("old-tabindex")), e.removeAttribute("old-tabindex")) : e.removeAttribute("tabindex");
			});
		}
		function M(e) {
			return !([
				"SCRIPT",
				"STYLE",
				"#document-fragment"
			].includes(e.nodeName) || e.hasAttribute("aria-live"));
		}
		function N(e) {
			g.filter(M).forEach((t) => {
				t.setAttribute("aria-hidden", e);
			});
		}
		function P(e) {
			if (e) {
				let e = F();
				e.length && setTimeout(() => e[0].focus(), 200);
			}
		}
		function F() {
			let e = y.value.querySelectorAll(p);
			return e && e.length ? e : [];
		}
		function I() {
			let e = F();
			if (e.length) {
				let t = v.value ? e.length - 1 : 0;
				v.value = !0, e[t].focus();
			}
		}
		function L() {
			let e = F();
			e.length > 0 && e[0].focus();
		}
		return (e, t) => u.isVisible ? (n(), d("div", {
			key: 0,
			ref_key: "vueFocusLoopContainer",
			ref: b,
			class: "vue-focus-loop"
		}, [
			u.loop ? (n(), d("div", {
				key: 0,
				tabindex: C.value,
				"aria-hidden": "true",
				class: "sr-only",
				onFocus: I
			}, null, 40, m)) : s("", !0),
			c("div", {
				ref_key: "focusLoop",
				ref: y
			}, [i(e.$slots, "default")], 512),
			u.loop ? (n(), d("div", {
				key: 1,
				tabindex: C.value,
				class: "sr-only",
				"aria-hidden": "true",
				onFocus: L
			}, null, 40, h)) : s("", !0)
		], 512)) : s("", !0);
	}
}, [["styles", [p]]]);
//#endregion
export { g as t };
